import React from 'react';

import { DatePicker } from 'antd';


const DatePickerCustom = (props) => {
  return (
    <DatePicker {...props} />
  );
};

export default DatePickerCustom;